import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const toggleContainerCss: CSSObject = {
  display: "flex",
  justifyContent: "end",
};

export const toggleButtonCss: CSSObject = {
  backgroundColor: ui.neutral[25],
  padding: "9px 12px",
};

export const headerButtonsContainerCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "auto auto",
  alignItems: "center",
  width: "100%",
};
